export const defaultIPv4Address: number[] = [0, 0, 0, 0];

export const DEFAULT_ROUTE = "0.0.0.0/0";

export const MAX_IPV4_ADDRESS_SUMMARY = 5;

export const MIN_IPV4_ADDRESS_SUMMARY = 2;
